/**
 * Classe che registra eventi distribuiti sull'intera app.
 * Usage:
 * SignalService.on('eventName', (args) => func1(args))
 * ...
 * SignalService.fire('eventName', ...args)
 *
 * Per gli eventi conosciuti usare SignalType
 */
export default class SignalsService {
  private static SIGNAL_MAP: Map<string, any> = new Map()

  /**
   * Registra la funzione all'evento (può essere chiamato più volte, registrando quindi più funzioni)
   *
   * @param name
   * @param fn
   */
  public static on(name: string, fn: any) {
    const fns = this.SIGNAL_MAP.has(name)
      ? this.SIGNAL_MAP.get(name)
      : this.SIGNAL_MAP.set(name, new Set()).get(name)
    fns.add(fn)
  }

  /**
   * Cancella tutte le funzioni associate all'evento
   *
   * @param name
   */
  public static off(name: string) {
    if (!this.SIGNAL_MAP.has(name)) {
      console.error('SignalsService', 'Error getting registered event', name)
    } else {
      this.SIGNAL_MAP.delete(name)
    }
  }

  /**
   * Richiama la funzione associata all'evento
   *
   * @param name
   * @param args
   */
  public static fire(name: string, ...args: any) {
    if (!this.SIGNAL_MAP.has(name)) {
      console.error('SignalsService', 'Error getting registered event', name)
    } else {
      const fns = this.SIGNAL_MAP.get(name)

      if (!fns.size) {
        console.error('SignalsService', 'Error getting registered event')
      } else {
        for (const fn of fns) {
          fn(...args)
        }
      }
    }
  }

  /**
   * Richiama la funzione associata all'evento una sola volta, e rimuove l'evento
   *
   * @param name
   * @param args
   */
  public static fireOnce(name: string, ...args: any) {
    this.fire(name, args)
    this.off(name)
  }
}

export const SignalType = {
  OPEN_MODAL: 'openModal',
  CLOSE_MODAL: 'closeModal',
  CLOSE_GAME: 'closeGame',
  OPEN_MODAL_BOTTOM: 'openModalBottom',
  CLOSE_MODAL_BOTTOM: 'closeModalBottom',
  OPEN_TOOLTIP: 'openTooltip',
  CLOSE_TOOLTIP: 'closeTooltip',
  SHOW_LOADER: 'showLoader',
  DISMISS_LOADER: 'dismissLoader',
  TRACKING: 'tracking',
  TRACKING_PAGECHANGED: 'trackingPageChanged',
  PLAY_GAME: 'playGame',
  TRY_GAME: 'tryGame',
  REOPEN_GAME: 'reopenGame',
  BUY_GAME: 'acquista',
  SWITCH_TO_PLAY: 'switchToPlay',
  NEW_NOTIFICATION: 'newNotification',
  SEARCHBAR: 'searchbar'
}
